import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidatePaymentDetailsQueries } from '@/modules/common/utils/query-invalidation';

import { deletePaymentDetails } from '../../api/payment-details.api';

export const useDeletePaymentDetails = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.settings');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (id: number) => deletePaymentDetails(id),
    onSuccess: async () => {
      await invalidatePaymentDetailsQueries(queryClient);
      displayToastSuccess(t('pages.finance.paymentDetails.toasts.deleted'));
      onSuccess?.();
    },
    onError: error =>
      displayToastErrorFromApiWithFallback(
        error,
        'authenticated.settings:api.error.paymentDetails.deleteFailed'
      ),
  });
};
